<div class="letter-avatar avatar" [ngClass]="{ small: isSmall, large: isLarge }"
  [style.backgroundImage]="styleObj.backgroundImage">
</div>